<template>
    <div>
        <!-- <div style="height: 430px;background-size: 100% 100%;"
            :style="{ backgroundImage: 'url(' + require('@/assets/images/ny-bannar1.jpg') + ')' }">
            <div style="width: 1200px;margin: 0px auto;height: 100%;font-size: 16px;" class="file falign">
                <div style="width: 155px;border-right: 3px solid #fff;">
                    <div :class="[{ 'mindex': mindex == i }, { 'menu': mindex != i }]" @click="getInfo(x.ID, i)"
                        style="height: 40px;padding-right: 30px;text-align: right;line-height:40px;cursor: pointer;"
                        v-for="(x, i) in menus">{{
                            x.name }}</div>
                </div>
                <div style="flex: 1;padding-left: 90px;">
                    <div style="font-size: 40px;">{{ data.title }}</div>
                    <div style="margin-top: 40px;width: 50%;">{{ data.text }}</div>
                    <div @click="toc"
                        style="margin-top: 44px;width: 140px;height: 40px;line-height: 40px;text-align: center;background: #1e66d1;color: #fff;cursor: pointer;">
                        获取完整方案</div>
                </div>
            </div>
        </div> -->
        <!-- ========== 制造行业 ========== -->
        <div class="industry-content active" id="industry-manufacturing" v-if="data">
            <section class="hero" style="background: rgb(242 249 255 / 50%)">
                <div class="container" style="display: flex;justify-content: space-between;">
                    <div style="width: 155px;border-right: 3px solid #fff;">
                        <div :class="[{ 'mindex': mindex == i }, { 'menu': mindex != i }]" @click="getInfo(x.ID, i)"
                            style="height: 45px;padding-right: 30px;text-align: right;line-height:45px;cursor: pointer;"
                            v-for="(x, i) in menus">{{
                                x.name }}</div>
                    </div>
                    <div class="hero-inner" style="margin-left: 80px;">
                        <div class="hero-left" style="margin-top: 20px;">
                            <!-- <div class="hero-badge"><span></span>{{ data.badge }}</div> -->
                            <h1>{{ data.industryName }}<br><span class="highlight">{{ data.title }}</span></h1>
                            <p class="hero-subtitle">{{ data.desc }}</p>
                            <div class="hero-cta" style="margin-top: 50px;">
                                <a style="cursor: pointer;" @click="toc" class="btn btn-primary">获取完整方案</a>
                                <a @click="getmodule" class="btn btn-outline">查看应用场景</a>
                            </div>
                            <!-- <div class="hero-stats">
                                <div class="stat" v-for="(z, j) in data.stats" :key="j">
                                    <div class="stat-number">{{ z.num }}</div>
                                    <div class="stat-label">{{ z.label }}</div>
                                </div>
                            </div> -->
                        </div>
                        <div class="hero-right" style="zoom: 0.9;width: 450px;margin-left: 60px;">
                            <div class="ai-card">
                                <div class="ai-card-head">
                                    <div class="ai-avatar">AI</div>
                                    <div>
                                        <h4>{{ data.aiAssistant.name }}</h4>
                                        <p>{{ data.aiAssistant.subTitle }}</p>
                                    </div>
                                    <div class="status">{{ data.aiAssistant.status }}</div>
                                </div>
                                <div class="ai-msgs">
                                    <div class="ai-msg" v-for="(z, j) in data.aiAssistant.msgList" :key="j">
                                        <div class="ai-dot">AI</div>
                                        <div class="bubble">
                                            <h5>{{ z.title }}</h5>
                                            <p>{{ z.content }}</p><span class="tag">{{ z.tag }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section pain-section">
                <div class="container">
                    <div class="section-header reveal">
                        <h2 class="section-title">{{ data.painTitle }}</h2>
                        <p class="section-desc">{{ data.painDesc }} AI 解法。</p>
                    </div>
                    <div class="pain-layout">
                        <img src="../../assets/hometo/jjfa-bj.jpg"
                            style="position: absolute;top: -50px;transform: translate(-50%, -0%);left: 50%;width: 1000px;">
                        <div class="pain-col pain-col-left">
                            <!-- pain-card pain-card-highlight reveal -->
                            <div class="pain-card reveal" v-for="(z, j) in data.painList" :key="j" v-if="j < 3">
                                <h3>{{ z.title }}</h3>
                                <p>{{ z.desc }}</p>
                            </div>
                        </div>
                        <div class="pain-col pain-col-right">
                            <div class="pain-card reveal" v-for="(z, j) in data.painList" :key="j" v-if="j > 2">
                                <h3>{{ z.title }}</h3>
                                <p>{{ z.desc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section" id="scenarios-mfg">
                <div class="containercard" id="module3">
                    <div class="section-header reveal">
                        <!-- <div class="section-label">AI 应用场景</div> -->
                        <h2 class="section-title">{{ data.sceneTitle }}</h2>
                        <p class="section-desc">{{ data.sceneDesc }}</p>
                    </div>
                    <div class="slider-wrap" id="scrollcontainer">
                        <div class="slider scn-slider" data-slider="scn-mfg" style="user-select: none;width: 3500px;">
                            <div class="scenario-card reveal" v-for="(z, j) in data.sceneList" :key="j">
                                <div class="scenario-header">
                                    <div class="scenario-icon">{{ z.icon }}</div>
                                    <div class="scenario-title-group">
                                        <h3>{{ z.name }}</h3>
                                        <div class="scenario-tag">{{ z.tag }}</div>
                                    </div>
                                </div>
                                <p>{{ z.desc }}</p>
                                <div class="scenario-features">
                                    <span v-for="(w, k) in z.featureTags" :key="k">{{ w }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="slider-nav">
                            <button class="slider-btn slider-prev" data-target="scn-mfg">‹</button>
                            <div class="slider-dots" data-dots="scn-mfg"></div>
                            <button class="slider-btn slider-next" data-target="scn-mfg">›</button>
                        </div> -->
                    </div>
                </div>
            </section>

            <section class="section highlights">
                <div class="container">
                    <div class="section-header reveal">
                        <!-- <div class="section-label">解决方案亮点</div> -->
                        <h2 class="section-title">{{ data.highlightTitle }}</h2>
                        <p class="section-desc">{{ data.highlightDesc }}</p>
                    </div>
                    <div class="highlights-grid">
                        <div class="highlight-card reveal" v-for="(z, j) in data.highlightList" :key="j">
                            <div class="highlight-number">{{ z.num }}</div>
                            <h3>{{ z.title }}</h3>
                            <p>{{ z.desc }}</p>
                            <ul>
                                <li v-for="(w, k) in z.items" :key="k">{{ w }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- CTA -->
                <section class="cta-section" id="contact-制造企业">
                    <img src="../../assets/hometo/616.jpg" style="height: 380px;">
                    <div class="container"
                        style="position: absolute;left: 50%;transform: translate(-50%, -0%);top: 0px;z-index: 9;width: 1200px;">
                        <div class="cta-inner">
                            <div class="cta-content">
                                <h2>{{ data.ctaTitle }}</h2>
                                <p>{{ data.ctaDesc }}</p>
                                <!-- <div class="cta-actions">
                                    <a href="mailto:contact@sunjee.cn" class="btn btn-cta-primary">预约方案咨询</a>
                                    <a href="#scenarios-mfg" class="btn btn-cta-outline">了解应用场景</a>
                                </div> -->
                            </div>
                            <div class="cta-visual">
                                <div class="hero-visual" data-visual>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
var isMouseDown = false;
var ul = null;
export default {
    data() {
        return {
            mindex: 0,
            data: {},
            menus: [],
            list: [
                {
                    "id": "manufacturing",
                    "industryName": "制造行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的工业数字化转型方案",
                    "desc": "基于工业 AI 智能体、物联网与数据中台，构建轻量化、可落地的智能制造平台。覆盖设备预测性维护、AI视觉质检、智能排产、工艺优化、供应链预测及数字员工等全场景，助力制造企业降本增效、提质避险。",
                    "stats": [
                        { "num": "30%+", "label": "设备综合效率提升" },
                        { "num": "40%+", "label": "质检效率提升" },
                        { "num": "50%+", "label": "非计划停机下降" }
                    ],
                    "aiAssistant": {
                        "name": "工业 AI 智能助手",
                        "subTitle": "实时分析 · 主动决策 · 闭环执行",
                        "status": "设备运行正常",
                        "msgList": [
                            {
                                "title": "设备健康预警",
                                "content": "3# 产线空压机振动异常，预测 72 小时内轴承故障概率 87%，建议提前更换。",
                                "tag": "故障预测"
                            },
                            {
                                "title": "质量检测",
                                "content": "检测到钣金件表面划痕 3 处，已自动隔离并通知质检员，良品率 99.2%。",
                                "tag": "库存补货提醒"
                            },
                            {
                                "title": "工艺参数优化建议",
                                "content": "基于订单优先级与设备状态，已重新生成最优排程，交货周期可缩短 1.5 天。",
                                "tag": "智能排产"
                            }
                        ]
                    },
                    "painTitle": "制造业数字化转型的核心挑战",
                    "painDesc": "我们深入调研装备制造、汽车零部件、电子装配等细分行业，总结出六大共性痛点，每一项都有对应的 AI 解法。",
                    "painList": [
                        { "title": "设备突发故障停机", "desc": "关键设备依赖计划保养或事后维修，突发故障导致产线停滞、交期延误，维修成本与停机损失高。" },
                        { "title": "质检依赖人工经验", "desc": "传统人工目检效率低、漏检率高，复杂缺陷难以标准化，质量数据难以沉淀为工艺改进依据。" },
                        { "title": "排产响应市场变化慢", "desc": "订单波动、设备异常、物料不齐套时，排产调整耗时耗力，产能利用率与交付准时率难以兼顾。" },
                        { "title": "供应链信息不透明", "desc": "供应商交货、库存、物流信息分散，缺料与呆滞并存，采购决策依赖经验而非数据预测。" },
                        { "title": "工艺经验传承困难", "desc": "老师傅经验难以沉淀，新员工培养周期长，工艺参数调优缺乏数据支撑，产品一致性难保证。" },
                        { "title": "数据孤岛严重", "desc": "ERP、MES、SCADA、WMS 等系统数据割裂，报表汇总耗时，管理层难以实时掌握生产经营全貌。" }
                    ],
                    "sceneTitle": "覆盖生产、质量、运维与供应链全链路",
                    "sceneDesc": "从单点智能到全局协同，每个场景均基于企业现有数据与系统，提供可量化、可交付的落地方案。",
                    "sceneList": [
                        {
                            "icon": "🔧",
                            "name": "AI 预测性设备维护",
                            "tag": "降低非计划停机",
                            "desc": "传感器实时采集振动、温度等运行数据，AI 识别异常模式并提前 24–72 小时预警故障，自动生成维修工单与备件推荐。",
                            "featureTags": ["振动/温度分析", "故障根因定位", "备件预测", "维修知识库"]
                        },
                        {
                            "icon": "👁️",
                            "name": "AI 视觉质检",
                            "tag": "替代人工目检",
                            "desc": "工业相机 + 深度学习自动识别表面划痕、裂纹、缺件、色差等缺陷，毫秒级检测、缺陷分类与良品追溯。",
                            "featureTags": ["缺陷自动分类", "实时NG隔离", "检测数据追溯", "模型持续学习"]
                        },
                        {
                            "icon": "📅",
                            "name": "AI 智能排产",
                            "tag": "提升交付准时率",
                            "desc": "综合考虑订单优先级、产能、物料齐套等约束，AI 自动生成优化排程，插单/故障可快速重排并评估影响。",
                            "featureTags": ["多约束优化", "插单快速响应", "产能负荷预测", "交期风险预警"]
                        },
                        {
                            "icon": "⚙️",
                            "name": "AI 工艺参数优化",
                            "tag": "提质降耗",
                            "desc": "关联设备参数、工艺配方与质量结果，AI 推荐最优工艺窗口，持续学习自动微调关键参数，减少废品与返工。",
                            "featureTags": ["工艺窗口推荐", "能耗优化", "良率提升", "参数版本管理"]
                        },
                        {
                            "icon": "📦",
                            "name": "AI 供应链需求预测",
                            "tag": "降低库存成本",
                            "desc": "融合历史订单、市场趋势与供应商数据，AI 预测物料需求与库存水位，智能推荐采购批量与安全库存。",
                            "featureTags": ["需求预测", "安全库存优化", "供应商绩效评估", "智能补货提醒"]
                        },
                        {
                            "icon": "💬",
                            "name": "工业数字员工",
                            "tag": "提升人效",
                            "desc": "基于私有知识库构建制造 AI 助手，7×24 回答工艺、质量、设备问题，自动生成日报/周报、辅助新员工培训。",
                            "featureTags": ["知识问答", "报表自动生成", "工单智能处理", "培训助手"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 制造方案",
                    "highlightDesc": "不做\"空中楼阁\"的大平台，只做能贴合企业现状、快速产生业务价值的轻量化解决方案。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "场景化 AI 智能体",
                            "desc": "针对设备、质量、排产、供应链等具体场景，提供预训练模型 + 行业 know-how 的 AI 智能体。支持与私有知识库深度融合，开箱即用，快速见效。",
                            "items": ["行业知识库深度融合", "私有化部署保障数据安全", "持续学习企业数据迭代优化"]
                        },
                        {
                            "num": "02",
                            "title": "开放架构与系统兼容",
                            "desc": "标准化接口与协议适配，无缝对接 ERP、MES、SCADA、WMS 等系统，不推倒重来、不制造信息孤岛。模块化架构随业务演进按需扩展。",
                            "items": ["兼容主流工业系统与协议", "开放 API 低成本快速集成", "模块化架构按需弹性扩展"]
                        },
                        {
                            "num": "03",
                            "title": "端到端可落地交付",
                            "desc": "从业务调研、数据治理、模型训练、系统集成到上线运营，提供端到端交付服务。每个项目均设定可量化 KPI，确保投资回报可见。",
                            "items": ["POC 验证降低决策风险", "分阶段实施快速迭代", "培训 + 运维保障长期运行"]
                        },
                        {
                            "num": "04",
                            "title": "移动 + 协同一体化体验",
                            "desc": "基于移动端统一入口，将 AI 分析结果、预警通知、审批任务直达一线，实现\"问题发现—派单—处理—复盘\"闭环。",
                            "items": ["多端一致的操作体验", "实时消息推送与预警", "任务闭环与绩效追踪"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为制造企业的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "design",
                    "industryName": "设计院行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的协同设计方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖智能审图、协同设计、知识管理、项目管控的全场景数字化平台，助力设计院提质增效、规范交付。",
                    "stats": [
                        { "num": "70%+", "label": "审图效率提升" },
                        { "num": "40%+", "label": "设计协同沟通成本下降" },
                        { "num": "30%+", "label": "项目交付周期缩短" }
                    ],
                    "aiAssistant": {
                        "name": "设计院 AI 智能助手",
                        "subTitle": "智能审图 · 规范查询 · 协同提效",
                        "status": "项目运行正常",
                        "msgList": [
                            {
                                "title": "智能审图",
                                "content": "A 区施工图消防车道宽度不足，已标注 5 处规范冲突，审图效率提升 70%。",
                                "tag": "审图完成"
                            },
                            {
                                "title": "规范查询",
                                "content": "根据 GB50016-2014 第 7.1.8 条，商业综合体疏散距离不应大于 30m。",
                                "tag": "规范调取"
                            },
                            {
                                "title": "变更影响",
                                "content": "本次电梯井调整影响 3 个专业、12 张图纸，预计增加工时 32h，建议重排计划。",
                                "tag": "变更评估"
                            }
                        ]
                    },
                    "painTitle": "设计院数字化转型的核心挑战",
                    "painDesc": "建筑、市政、规划等设计院面临图纸管理、规范审核、协同效率与知识沉淀四大难题。",
                    "painList": [
                        { "title": "图纸版本管理混乱", "desc": "多专业图纸版本频繁变更，命名不规范、追踪困难，协作中经常出现版本冲突与遗漏。" },
                        { "title": "规范审核依赖人工", "desc": "设计规范、消防、结构等合规检查耗时耗力，人工审图易遗漏，返工率高。" },
                        { "title": "跨专业协同效率低", "desc": "建筑、结构、机电等专业沟通靠邮件与会议，变更影响难以快速评估，项目进度频繁延误。" },
                        { "title": "设计知识沉淀难", "desc": "历史项目经验散落在个人电脑与纸面文件中，新项目无法快速复用，人才流动导致知识流失。" },
                        { "title": "项目管控缺乏实时视图", "desc": "设计进度、工时投入、变更次数等关键指标分散在各系统，管理层难以实时掌握项目全貌。" },
                        { "title": "设计变更影响评估难", "desc": "一处变更可能波及多专业多图纸，影响范围与工作量难以快速量化，决策缺乏数据支撑。" }
                    ],
                    "sceneTitle": "覆盖设计、审图、协同与知识管理全链路",
                    "sceneDesc": "AI 智能体深入设计核心环节，从图纸审核到知识复用，全方位提质增效。",
                    "sceneList": [
                        {
                            "icon": "🔍",
                            "name": "AI 智能审图",
                            "tag": "规范合规自动检查",
                            "desc": "AI 自动识别图纸中的规范冲突、尺寸矛盾、消防间距不足等问题，生成审查意见清单，大幅减少人工审图工作量与漏检。",
                            "featureTags": ["规范冲突检测", "尺寸矛盾识别", "审查意见清单", "审图数据沉淀"]
                        },
                        {
                            "icon": "📐",
                            "name": "AI 辅助设计",
                            "tag": "方案生成提效",
                            "desc": "基于历史项目与设计规范，AI 辅助生成平面布局、结构选型、管线走向等初版方案，设计师在此基础上快速优化。",
                            "featureTags": ["方案初版生成", "规范合规校验", "参数化设计辅助", "方案对比推荐"]
                        },
                        {
                            "icon": "💬",
                            "name": "设计知识库 AI 问答",
                            "tag": "经验即时复用",
                            "desc": "构建设计院私有知识库，AI 助手即时回答规范条文、设计标准、历史项目做法等问题，新人上手快、老经验不流失。",
                            "featureTags": ["规范条文即时查询", "历史项目经验复用", "设计标准问答", "知识版本管理"]
                        },
                        {
                            "icon": "📱",
                            "name": "项目协同与移动门户",
                            "tag": "跨专业高效协作",
                            "desc": "基于企业微信统一入口，图纸审批、变更通知、会议纪要、工时填报等高频业务一键触达，跨专业协作实时同步。",
                            "featureTags": ["图纸审批在线", "变更通知实时推送", "工时填报移动端", "项目进度看板"]
                        },
                        {
                            "icon": "🔄",
                            "name": "智能变更影响分析",
                            "tag": "变更评估量化",
                            "desc": "AI 分析设计变更涉及的图纸、专业与工作量，自动评估影响范围与工期影响，辅助项目经理快速决策。",
                            "featureTags": ["影响范围自动识别", "工作量增量评估", "工期影响分析", "变更版本追踪"]
                        },
                        {
                            "icon": "📊",
                            "name": "项目经营数据分析",
                            "tag": "经营决策数据化",
                            "desc": "整合工时、合同、产值、回款等多维数据，AI 生成项目经营健康度评估与预警，支撑管理层精准决策。",
                            "featureTags": ["项目健康度评估", "产值与回款分析", "工时效率预警", "经营趋势预测"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 设计院方案",
                    "highlightDesc": "以 AI 智能体为核心，打通设计、审图、协同与经营全链路，真正实现\"提质增效、规范交付\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "AI 智能审图提效",
                            "desc": "深度学习自动检测规范冲突、尺寸矛盾、消防间距不足等常见问题，生成审查意见清单，审图效率提升 70%。",
                            "items": ["覆盖主流设计规范", "审查意见自动生成", "审图数据持续沉淀"]
                        },
                        {
                            "num": "02",
                            "title": "设计知识智能复用",
                            "desc": "私有知识库 + AI 问答，规范条文、历史项目做法即时查询，新员工上手快、老经验不流失，知识资产持续增值。",
                            "items": ["规范条文即时检索", "历史项目经验复用", "知识库持续更新迭代"]
                        },
                        {
                            "num": "03",
                            "title": "跨专业协同闭环",
                            "desc": "基于企业微信统一入口，图纸审批、变更通知、会议纪要实时同步，变更影响 AI 自动评估，消除信息滞后与版本冲突。",
                            "items": ["审批与变更在线闭环", "变更影响量化评估", "跨专业进度实时可见"]
                        },
                        {
                            "num": "04",
                            "title": "经营数据驱动决策",
                            "desc": "整合工时、合同、产值、回款多维数据，AI 生成项目健康度评估与趋势预测，管理层精准决策不再依赖直觉。",
                            "items": ["项目健康度实时评估", "经营趋势智能预测", "异常指标自动预警"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为设计院的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "retail",
                    "industryName": "零售行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的智慧零售方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖客流分析、智能选品、精准营销、门店运营的全场景智慧零售平台，助力零售企业提升坪效、转化与复购。",
                    "stats": [
                        { "num": "25%+", "label": "客流转化率提升" },
                        { "num": "30%+", "label": "库存周转效率提升" },
                        { "num": "40%+", "label": "会员复购率提升" }
                    ],
                    "aiAssistant": {
                        "name": "零售 AI 智能助手",
                        "subTitle": "客流洞察 · 精准触达 · 提坪效",
                        "status": "门店运营正常",
                        "msgList": [
                            {
                                "title": "客流分析",
                                "content": "周末客流较平日 +38%，A 区热区集中，建议补货 2 号货架并加派 1 名导购。",
                                "tag": "客流高峰"
                            },
                            {
                                "title": "选品推荐",
                                "content": "根据近 30 天销售数据，新款运动鞋预计日销 +25%，建议主推 A3 展位。",
                                "tag": "爆品预测"
                            },
                            {
                                "title": "营销转化",
                                "content": "会员王女士近 30 天复购 3 次，偏好母婴品类，AI 已生成 4 套个性化优惠券。",
                                "tag": "会员唤醒"
                            }
                        ]
                    },
                    "painTitle": "零售数字化转型的核心挑战",
                    "painDesc": "从连锁超市到品牌专卖店，客流、库存、营销与门店运营是四大共性难题。",
                    "painList": [
                        { "title": "客流转化率低", "desc": "进店客流数据缺失，停留时长与热区不明，无法量化坪效，促销效果难以评估。" },
                        { "title": "库存管理难", "desc": "选品靠经验、补货靠手工，畅销品缺货与滞销品积压并存，库存周转效率低。" },
                        { "title": "营销同质化", "desc": "促销活动千店一面，会员画像模糊，推荐不精准，私域流量难以有效转化。" },
                        { "title": "门店运营标准难统一", "desc": "陈列、卫生、服务标准执行靠人工督导，成本高且覆盖有限，执行偏差难及时发现。" },
                        { "title": "线上线下数据割裂", "desc": "电商与门店数据分属不同系统，会员、订单、库存无法打通，全渠道运营难以落地。" },
                        { "title": "成本结构难优化", "desc": "人力、能耗、损耗等成本项缺乏精细化数据，优化方向不明确，利润率持续承压。" }
                    ],
                    "sceneTitle": "覆盖客流、选品、营销与门店运营全链路",
                    "sceneDesc": "AI 智能体深入零售核心环节，从门店洞察到精准触达，全方位提升经营效率。",
                    "sceneList": [
                        {
                            "icon": "🚶",
                            "name": "AI 客流分析与热区识别",
                            "tag": "量化门店坪效",
                            "desc": "视频 + AI 实时统计进店客流、停留时长、热区分布与动线轨迹，自动生成坪效分析与促销效果评估。",
                            "featureTags": ["进店客流统计", "热区分布分析", "动线轨迹追踪", "促销效果量化"]
                        },
                        {
                            "icon": "📦",
                            "name": "AI 智能选品与需求预测",
                            "tag": "降低库存成本",
                            "desc": "融合销售数据、季节因素与市场趋势，AI 预测单品需求，自动推荐选品组合与补货策略，减少缺货与呆滞。",
                            "featureTags": ["单品需求预测", "选品组合推荐", "智能补货提醒", "滞销预警"]
                        },
                        {
                            "icon": "🎯",
                            "name": "AI 精准营销与会员运营",
                            "tag": "提升复购转化",
                            "desc": "AI 构建会员全景画像，自动生成个性化推荐与营销内容，通过企微社群 + 朋友圈精准触达，沉淀私域流量。",
                            "featureTags": ["会员画像构建", "个性化推荐", "AI内容生成", "私域社群运营"]
                        },
                        {
                            "icon": "👁️",
                            "name": "门店智能督导",
                            "tag": "远程巡店提效",
                            "desc": "视频 + AI 自动检测陈列合规、卫生状况、人员着装等标准执行情况，生成巡店报告，替代人工督导。",
                            "featureTags": ["陈列合规检测", "卫生状况识别", "巡店报告自动生成", "异常即时告警"]
                        },
                        {
                            "icon": "🤖",
                            "name": "智能客服与导购助手",
                            "tag": "7×24 服务响应",
                            "desc": "基于商品知识库构建 AI 导购助手，顾客随时查询商品、获取搭配推荐与优惠信息，门店员工也可快速查询库存与政策。",
                            "featureTags": ["商品智能查询", "搭配推荐", "优惠信息推送", "库存快速查询"]
                        },
                        {
                            "icon": "📊",
                            "name": "全渠道数据打通",
                            "tag": "线上线下一体化",
                            "desc": "打通电商、门店、企微私域数据，统一会员、订单、库存视图，支持全渠道营销与供应链协同。",
                            "featureTags": ["会员统一视图", "订单库存打通", "全渠道营销协同", "经营数据看板"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 零售方案",
                    "highlightDesc": "以 AI 智能体为核心，连接客流、选品、营销与运营全场景，真正实现\"提质增效、精准触达\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "智慧门店运营",
                            "desc": "客流热区量化坪效，AI 督导替代人工巡店，陈列/卫生/服务标准自动检测，运营成本下降 30%。",
                            "items": ["客流热区实时分析", "陈列合规自动检测", "远程巡店报告生成"]
                        },
                        {
                            "num": "02",
                            "title": "精准营销转化",
                            "desc": "AI 构建会员画像，个性化推荐 + AI 内容生成 + 企微私域运营，从引流到复购全链路提效。",
                            "items": ["会员全景画像", "个性化推荐引擎", "私域流量沉淀转化"]
                        },
                        {
                            "num": "03",
                            "title": "供应链智能优化",
                            "desc": "AI 预测单品需求，自动推荐选品与补货策略，畅销不缺货、滞销不积压，库存周转效率提升 30%。",
                            "items": ["需求预测与选品推荐", "智能补货与滞销预警", "全渠道库存统一视图"]
                        },
                        {
                            "num": "04",
                            "title": "全渠道一体化",
                            "desc": "打通电商、门店、私域数据，会员、订单、库存统一视图，支持全渠道营销协同与经营数据看板。",
                            "items": ["会员订单库存打通", "全渠道营销协同", "经营数据实时看板"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为零售企业的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "finance",
                    "industryName": "金融行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的金融科技方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖智能风控、精准营销、合规审计、智能投顾的全场景金融科技平台，助力金融机构提质增效、合规避险。",
                    "stats": [
                        { "num": "50%+", "label": "风控识别准确率提升" },
                        { "num": "60%+", "label": "客服响应效率提升" },
                        { "num": "40%+", "label": "合规审计效率提升" }
                    ],
                    "aiAssistant": {
                        "name": "金融 AI 智能助手",
                        "subTitle": "风控识别 · 合规审计 · 7×24 服务",
                        "status": "系统运行正常",
                        "msgList": [
                            {
                                "title": "风险识别",
                                "content": "客户张XX 申请金额 80 万，行为画像异常，AI 建议人工复核，欺诈概率 78%。",
                                "tag": "风险预警"
                            },
                            {
                                "title": "智能客服",
                                "content": "7×24 解答存贷款、理财、信用卡问题，秒级响应，今日已承接 2,184 通咨询。",
                                "tag": "在线服务"
                            },
                            {
                                "title": "资产配置",
                                "content": "客户风险等级 C3，可配置 20% 权益类资产，推荐 3 套组合，预计年化 5.2%。",
                                "tag": "智能投顾"
                            }
                        ]
                    },
                    "painTitle": "金融数字化转型的核心挑战",
                    "painDesc": "银行、保险、证券等金融机构面临风控、合规、客服与精准营销四大共性难题。",
                    "painList": [
                        { "title": "风险识别滞后", "desc": "传统风控依赖规则引擎，误报率高、新型欺诈难识别，实时风险敞口难以量化。" },
                        { "title": "客服压力大响应慢", "desc": "客户咨询量激增，人工客服排队严重，复杂问题处理慢，客户满意度下降。" },
                        { "title": "合规审计繁琐", "desc": "监管要求日益严格，合规审查与审计取证工作量巨大，人工处理耗时且易遗漏。" },
                        { "title": "产品推荐不精准", "desc": "客户画像维度有限，产品匹配靠经验，转化率低、交叉销售机会流失。" },
                        { "title": "投顾服务门槛高", "desc": "专业投顾覆盖有限，大众客户难以获得个性化资产配置建议，服务下沉成本高。" },
                        { "title": "数据安全合规要求严", "desc": "金融数据敏感度高，AI 应用需满足数据不出域、可审计、可追溯等严苛合规要求。" }
                    ],
                    "sceneTitle": "覆盖风控、合规、客服与精准营销全链路",
                    "sceneDesc": "AI 智能体深入金融核心环节，从风险识别到客户服务，全方位提质增效。",
                    "sceneList": [
                        {
                            "icon": "🛡️",
                            "name": "AI 智能风控与反欺诈",
                            "tag": "实时风险识别",
                            "desc": "融合交易行为、设备指纹、社交网络等多维数据，AI 实时识别欺诈交易与异常行为，大幅降低误报率。",
                            "featureTags": ["实时欺诈识别", "异常行为检测", "风险敞口量化", "风控模型持续迭代"]
                        },
                        {
                            "icon": "🤖",
                            "name": "7×24 智能客服与营销助手",
                            "tag": "服务响应提效",
                            "desc": "基于产品知识库构建 AI 客服，即时回答产品、利率、流程等问题；营销助手自动生成话术与跟进提醒。",
                            "featureTags": ["产品知识问答", "业务流程引导", "营销话术生成", "客户跟进提醒"]
                        },
                        {
                            "icon": "💰",
                            "name": "智能投顾与资产配置",
                            "tag": "服务下沉大众",
                            "desc": "AI 根据客户风险偏好与资产状况，自动生成个性化资产配置方案与投资建议，降低投顾服务门槛。",
                            "featureTags": ["风险评估与画像", "资产配置方案", "投资组合优化", "市场动态提醒"]
                        },
                        {
                            "icon": "📋",
                            "name": "合规审计自动化",
                            "tag": "降低合规成本",
                            "desc": "AI 自动审查交易记录、客户资料与操作日志，识别合规违规点并生成审计报告，大幅降低人工合规工作量。",
                            "featureTags": ["违规行为自动识别", "审计取证自动化", "合规报告生成", "监管指标实时监控"]
                        },
                        {
                            "icon": "🎯",
                            "name": "精准客户画像与推荐",
                            "tag": "提升转化率",
                            "desc": "AI 构建多维客户画像，自动匹配金融产品与营销策略，精准触达目标客户，提升交叉销售转化率。",
                            "featureTags": ["多维客户画像", "产品智能匹配", "营销策略推荐", "转化效果追踪"]
                        },
                        {
                            "icon": "📈",
                            "name": "研报生成与市场分析",
                            "tag": "决策数据化",
                            "desc": "AI 自动汇总市场数据与行业资讯，生成研报摘要与趋势分析，辅助投资决策与业务规划。",
                            "featureTags": ["资讯自动汇总", "研报摘要生成", "趋势分析预测", "异常波动预警"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 金融方案",
                    "highlightDesc": "以 AI 智能体为核心，满足金融行业严苛的安全合规要求，真正实现\"提质增效、合规避险\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "智能风控合规",
                            "desc": "AI 实时识别欺诈与违规行为，合规审计自动化，误报率下降、审计效率提升，满足监管可追溯要求。",
                            "items": ["实时欺诈识别与预警", "合规审计自动化", "全链路可追溯可审计"]
                        },
                        {
                            "num": "02",
                            "title": "精准客户服务",
                            "desc": "AI 客服即时响应，智能投顾下沉大众客户，精准画像驱动产品推荐，客户满意度与转化率双提升。",
                            "items": ["7×24 AI 客服即时响应", "智能投顾个性化配置", "精准画像驱动推荐"]
                        },
                        {
                            "num": "03",
                            "title": "私有化安全部署",
                            "desc": "全栈私有化部署，数据不出域、模型可审计、操作可追溯，满足金融行业最严苛的安全合规要求。",
                            "items": ["数据不出域全程加密", "模型决策可解释可审计", "操作日志完整追溯"]
                        },
                        {
                            "num": "04",
                            "title": "开放架构与系统兼容",
                            "desc": "标准化接口对接核心银行、信贷、理财等系统，不推倒重来，模块化架构随业务演进按需扩展。",
                            "items": ["兼容核心银行业务系统", "开放 API 快速集成", "模块化按需弹性扩展"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为金融机构的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "pharma",
                    "industryName": "医药行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的医药数字化方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖研发辅助、临床数据、学术营销、合规管理的全场景医药数字化平台，助力药企提质增效、合规运营。",
                    "stats": [
                        { "num": "35%+", "label": "研发靶点筛选效率提升" },
                        { "num": "40%+", "label": "学术营销内容生成效率提升" },
                        { "num": "50%+", "label": "合规审查效率提升" }
                    ],
                    "aiAssistant": {
                        "name": "医药 AI 智能助手",
                        "subTitle": "研发辅助 · 学术营销 · 合规审查",
                        "status": "系统运行正常",
                        "msgList": [
                            {
                                "title": "研发辅助",
                                "content": "基于 12 万篇文献分析，靶点 EGFR-T790M 相关化合物 27 个，已筛选 3 个高活性候选。",
                                "tag": "研发提速"
                            },
                            {
                                "title": "学术内容",
                                "content": "已为新药 XX-2024 自动生成 4 篇学术推广材料初稿，合规审查通过 3 篇。",
                                "tag": "内容生成"
                            },
                            {
                                "title": "拜访计划",
                                "content": "HCP 王主任本周有 2 次学术会议，建议周二上午拜访，附 3 套个性化资料。",
                                "tag": "拜访推荐"
                            }
                        ]
                    },
                    "painTitle": "医药数字化转型的核心挑战",
                    "painDesc": "从创新药企到仿制药企业，研发、临床、营销与合规是四大共性难题。",
                    "painList": [
                        { "title": "新药研发周期长成本高", "desc": "靶点筛选、化合物优化耗时长，临床前数据量大且分散，研发决策缺乏系统性数据支撑。" },
                        { "title": "临床数据管理复杂", "desc": "多中心临床数据标准化难，合规要求严，数据清洗与统计分析周期长。" },
                        { "title": "医药代表管理松散", "desc": "代表拜访记录分散，效能难以量化，培训考核缺乏标准化流程与数据支撑。" },
                        { "title": "学术营销效果难量化", "desc": "学术会议与内容营销投入大，HCP 触达与转化难以追踪，ROI 评估模糊。" },
                        { "title": "合规审查要求严", "desc": "药品推广合规、数据隐私等监管要求日益严格，人工审查耗时且易遗漏。" },
                        { "title": "学术内容更新快培训压力大", "desc": "医学知识迭代快，代表与 HCP 培训内容制作成本高，更新不及时。" }
                    ],
                    "sceneTitle": "覆盖研发、临床、营销与合规全链路",
                    "sceneDesc": "AI 智能体深入医药核心环节，从靶点筛选到合规审查，全方位提质增效。",
                    "sceneList": [
                        {
                            "icon": "🔬",
                            "name": "AI 辅助药物研发",
                            "tag": "靶点筛选提效",
                            "desc": "AI 分析基因组、蛋白质结构与文献数据，辅助靶点筛选与化合物优化，缩短研发前期周期。",
                            "featureTags": ["靶点筛选辅助", "化合物优化推荐", "文献智能检索", "研发数据整合"]
                        },
                        {
                            "icon": "📊",
                            "name": "智能临床数据管理",
                            "tag": "合规高效",
                            "desc": "AI 辅助多中心临床数据标准化与清洗，自动检测数据异常与合规违规，加速统计分析。",
                            "featureTags": ["数据标准化清洗", "异常自动检测", "合规违规识别", "统计分析加速"]
                        },
                        {
                            "icon": "🧑‍⚕️",
                            "name": "医药代表智能助手",
                            "tag": "拜访效能提升",
                            "desc": "基于企微构建代表工作台，AI 辅助拜访计划制定、HCP 画像查询、话术推荐与拜访记录自动生成。",
                            "featureTags": ["拜访计划智能排程", "HCP画像查询", "话术推荐", "拜访记录自动生成"]
                        },
                        {
                            "icon": "📝",
                            "name": "AI 学术内容生成",
                            "tag": "营销内容提效",
                            "desc": "AI 自动生成学术推广材料、会议摘要与 HCP 个性化内容，合规审查前置，确保内容合规。",
                            "featureTags": ["学术材料自动生成", "会议摘要生成", "合规审查前置", "HCP 个性化内容"]
                        },
                        {
                            "icon": "🔒",
                            "name": "合规智能审查",
                            "tag": "降低合规风险",
                            "desc": "AI 自动审查推广材料、拜访话术与数据使用是否符合药品管理法与隐私法规，违规点即时标注。",
                            "featureTags": ["推广材料合规审查", "话术合规检查", "数据隐私审计", "违规即时标注"]
                        },
                        {
                            "icon": "📚",
                            "name": "医学知识库与培训",
                            "tag": "学习提效",
                            "desc": "构建药品知识库 + AI 问答，代表随时查询产品与疾病知识，培训内容 AI 生成与考核自动化。",
                            "featureTags": ["产品知识即时查询", "疾病知识问答", "培训内容AI生成", "考核自动化"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 医药方案",
                    "highlightDesc": "以 AI 智能体为核心，满足医药行业严苛的合规要求，真正实现\"提质增效、合规运营\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "研发与临床提效",
                            "desc": "AI 辅助靶点筛选与化合物优化，临床数据标准化与清洗自动化，缩短研发周期、降低临床数据管理成本。",
                            "items": ["靶点筛选与化合物优化", "临床数据标准化清洗", "异常与合规自动检测"]
                        },
                        {
                            "num": "02",
                            "title": "学术营销合规闭环",
                            "desc": "AI 生成学术内容 + 合规审查前置，推广材料与话术合规自动检查，违规点即时标注，营销合规双保障。",
                            "items": ["学术内容 AI 高效生成", "合规审查前置自动化", "违规即时标注与拦截"]
                        },
                        {
                            "num": "03",
                            "title": "代表效能数据化管理",
                            "desc": "企微工作台 + AI 助手，拜访计划智能排程、HCP 画像即时查询、话术推荐、拜访记录自动生成，效能可量化。",
                            "items": ["拜访计划智能排程", "HCP 画像与话术推荐", "拜访记录自动生成追踪"]
                        },
                        {
                            "num": "04",
                            "title": "私有化安全部署",
                            "desc": "全栈私有化部署，数据不出域、操作可追溯，满足医药行业最严苛的数据隐私与合规要求。",
                            "items": ["数据不出域全程加密", "操作日志完整追溯", "合规审计可追溯"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为医药企业的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "group",
                    "industryName": "集团企业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的集团数字化方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖统一协同、智能管控、数据驾驶舱、流程自动化的全场景集团数字化平台，助力集团企业打破孤岛、协同增效。",
                    "stats": [
                        { "num": "40%+", "label": "跨部门协作效率提升" },
                        { "num": "50%+", "label": "审批处理效率提升" },
                        { "num": "30%+", "label": "经营决策效率提升" }
                    ],
                    "aiAssistant": {
                        "name": "集团 AI 智能助手",
                        "subTitle": "统一协同 · 经营洞察 · 智能管控",
                        "status": "集团运行正常",
                        "msgList": [
                            {
                                "title": "经营数据",
                                "content": "本月合并营收 2.4 亿，环比 +5.2%，华南子公司贡献率 38%，AI 已生成经营月报。",
                                "tag": "经营简报"
                            },
                            {
                                "title": "审批提效",
                                "content": "差旅报销单 143 笔已 AI 预审，识别异常 7 笔自动转人工，预计审批提速 60%。",
                                "tag": "智能审批"
                            },
                            {
                                "title": "合规检查",
                                "content": "本周抽查合同 86 份，发现 2 处条款需补充，建议法务复核。",
                                "tag": "合规审查"
                            }
                        ]
                    },
                    "painTitle": "集团企业数字化转型的核心挑战",
                    "painDesc": "多地域、多业务、多系统的集团企业，协同、管控与决策是三大共性难题。",
                    "painList": [
                        { "title": "子公司系统林立数据割裂", "desc": "各子公司独立采购系统，数据标准不一，总部无法实时获取全集团经营数据。" },
                        { "title": "跨地域协同效率低", "desc": "总部与子公司、跨部门沟通依赖邮件与会议，信息传导失真，决策响应慢。" },
                        { "title": "流程标准不统一", "desc": "审批、报销、采购等流程各子公司标准不一，执行追踪困难，合规风险高。" },
                        { "title": "管理层缺乏实时经营视图", "desc": "经营数据分散在各系统与报表中，汇总周期长，管理层难以实时掌握集团全貌。" },
                        { "title": "总部与一线信息传导失真", "desc": "战略下达靠层层转发，一线执行反馈靠月度汇报，信息衰减与延迟严重。" },
                        { "title": "合规风控覆盖不全", "desc": "多地域多业务合规要求各异，人工审查覆盖有限，违规风险难以全面管控。" }
                    ],
                    "sceneTitle": "覆盖协同、管控、决策与流程全链路",
                    "sceneDesc": "AI 智能体深入集团管理核心环节，从统一协同到智能管控，全方位提质增效。",
                    "sceneList": [
                        {
                            "icon": "📱",
                            "name": "集团统一协同门户",
                            "tag": "打破信息孤岛",
                            "desc": "基于企微构建集团统一入口，整合通知、审批、报表、知识库等高频业务，总部与子公司一端协同。",
                            "featureTags": ["通知精准推送", "审批统一入口", "报表一键查询", "知识库即时检索"]
                        },
                        {
                            "icon": "🤖",
                            "name": "集团数字员工",
                            "tag": "人效提升",
                            "desc": "基于集团知识库构建 AI 助手，7×24 回答制度、流程、业务问题，自动生成汇报材料与会议纪要。",
                            "featureTags": ["制度流程即时问答", "汇报材料自动生成", "会议纪要AI整理", "跨子公司知识共享"]
                        },
                        {
                            "icon": "📊",
                            "name": "集团数据驾驶舱",
                            "tag": "经营实时可见",
                            "desc": "整合各子公司经营数据，AI 生成集团级实时驾驶舱，异常指标自动预警，管理层随时掌握全局。",
                            "featureTags": ["集团经营实时看板", "子公司对比分析", "异常指标自动预警", "趋势预测"]
                        },
                        {
                            "icon": "✅",
                            "name": "智能审批与流程自动化",
                            "tag": "审批提效合规",
                            "desc": "AI 辅助审批决策——自动校验合规规则、识别异常报销、推荐审批路径，流程标准化与提效双保障。",
                            "featureTags": ["合规规则自动校验", "异常报销识别", "审批路径智能推荐", "流程标准化管控"]
                        },
                        {
                            "icon": "🛡️",
                            "name": "合规风控智能审查",
                            "tag": "风险全面管控",
                            "desc": "AI 自动审查各子公司合同、采购、报销等合规性，违规点即时标注与告警，风控覆盖全集团。",
                            "featureTags": ["合同合规审查", "采购违规识别", "报销异常检测", "风控覆盖全集团"]
                        },
                        {
                            "icon": "💬",
                            "name": "AI 经营分析助手",
                            "tag": "决策数据化",
                            "desc": "基于经营数据 + AI，自动生成经营分析报告与趋势预测，辅助管理层精准决策，替代手工汇总与直觉判断。",
                            "featureTags": ["经营报告自动生成", "趋势预测分析", "异常经营预警", "策略建议推荐"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 集团方案",
                    "highlightDesc": "以 AI 智能体为核心，打破集团信息孤岛，真正实现\"统一协同、智能管控、数据驱动\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "统一协同平台",
                            "desc": "基于企微构建集团统一入口，通知、审批、报表、知识库一端聚合，总部与子公司高效协同。",
                            "items": ["通知审批一端聚合", "跨子公司即时协作", "知识库统一检索共享"]
                        },
                        {
                            "num": "02",
                            "title": "集团智能管控",
                            "desc": "数据驾驶舱实时呈现集团经营全貌，合规风控 AI 自动审查覆盖全集团，异常即时预警。",
                            "items": ["集团经营实时看板", "合规风控自动审查", "异常指标即时预警"]
                        },
                        {
                            "num": "03",
                            "title": "数据驱动决策",
                            "desc": "AI 经营分析助手自动生成报告与趋势预测，管理层精准决策不再依赖手工汇总与直觉判断。",
                            "items": ["经营报告自动生成", "趋势预测与策略推荐", "异常经营即时预警"]
                        },
                        {
                            "num": "04",
                            "title": "开放架构弹性扩展",
                            "desc": "标准化接口对接各子公司现有系统，不推倒重来，模块化架构随业务演进按需接入新模块。",
                            "items": ["兼容子公司现有系统", "开放 API 低成本集成", "模块化按需弹性扩展"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为集团企业的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "government",
                    "industryName": "政务行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的数字政务方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖智能问答、一网通办、基层减负、数据治理的全场景数字政务平台，助力政务服务提质、基层减负增效。",
                    "stats": [
                        { "num": "60%+", "label": "群众咨询响应效率提升" },
                        { "num": "40%+", "label": "基层事务处理效率提升" },
                        { "num": "30%+", "label": "跨部门数据共享率提升" }
                    ],
                    "aiAssistant": {
                        "name": "政务 AI 智能助手",
                        "subTitle": "智能问答 · 一网通办 · 基层减负",
                        "status": "系统运行正常",
                        "msgList": [
                            {
                                "title": "群众咨询",
                                "content": "今日接入 1,824 通咨询，AI 已解答 91%，TOP3 问题为营业执照、社保、公积金。",
                                "tag": "7×24 在线"
                            },
                            {
                                "title": "一网通办",
                                "content": "身份证办理已支持全流程线上预审，材料自动核验通过率 92%，平均 8 分钟办结。",
                                "tag": "一次办结"
                            },
                            {
                                "title": "应急调度",
                                "content": "明晚 8-10 时预计有暴雨，已自动推送 12 支应急队伍待命，建议提前排查 5 处低洼路段。",
                                "tag": "应急预警"
                            }
                        ]
                    },
                    "painTitle": "政务数字化转型的核心挑战",
                    "painDesc": "从省市级到基层街道，群众服务、基层减负、数据共享与决策支撑是四大共性难题。",
                    "painList": [
                        { "title": "群众办事难流程繁琐", "desc": "办事流程复杂、材料要求不透明，群众反复跑窗口，咨询量大且人工解答效率低。" },
                        { "title": "基层工作人员负担重", "desc": "报表多、台账多、证明多，大量时间消耗在填表与报送，核心服务时间被挤占。" },
                        { "title": "跨部门数据共享难", "desc": "各委办局数据标准不一、系统割裂，群众办事需重复提交材料，协同审批周期长。" },
                        { "title": "政策落地效果难量化", "desc": "政策执行数据分散，效果评估靠定性汇报，缺乏数据化量化支撑与持续跟踪机制。" },
                        { "title": "应急响应缺乏数据支撑", "desc": "突发事件信息获取滞后，跨部门协调靠人工，应急指挥缺乏实时数据与智能调度。" },
                        { "title": "数据安全合规要求严", "desc": "政务数据涉及公民隐私与国家安全，AI 应用需满足最严苛的安全合规与可审计要求。" }
                    ],
                    "sceneTitle": "覆盖政务服务、基层减负、数据治理与应急全链路",
                    "sceneDesc": "AI 智能体深入政务核心环节，从群众服务到基层减负，全方位提质增效。",
                    "sceneList": [
                        {
                            "icon": "🤖",
                            "name": "智能政务问答助手",
                            "tag": "群众服务提效",
                            "desc": "基于政务知识库构建 AI 问答，群众随时查询办事指南、材料清单、政策解读，7×24 即时响应。",
                            "featureTags": ["办事指南即时查询", "材料清单智能梳理", "政策解读问答", "7×24 即时响应"]
                        },
                        {
                            "icon": "📱",
                            "name": "一网通办智能导办",
                            "tag": "办事少跑腿",
                            "desc": "AI 分析群众办事需求，自动推荐最优办理路径与材料预审，线上预审通过后再到窗口一次办结。",
                            "featureTags": ["最优办理路径推荐", "材料预审与纠错", "线上预审线下一次办", "进度实时追踪"]
                        },
                        {
                            "icon": "📋",
                            "name": "基层减负智能工作台",
                            "tag": "报表台账自动化",
                            "desc": "AI 自动生成报表与台账，智能填写重复字段，基层工作人员聚焦核心服务而非填表报送。",
                            "featureTags": ["报表自动生成", "台账智能填写", "重复字段自动填充", "报送一键提交"]
                        },
                        {
                            "icon": "📚",
                            "name": "政策智能解读与匹配",
                            "tag": "政策精准触达",
                            "desc": "AI 自动解读新政策条款，匹配受影响企业与群众群体，精准推送与提醒，政策落地不再靠层层转发。",
                            "featureTags": ["政策条款自动解读", "受影响群体匹配", "精准推送提醒", "落地效果追踪"]
                        },
                        {
                            "icon": "🚨",
                            "name": "应急指挥智能调度",
                            "tag": "响应实时化",
                            "desc": "AI 整合多源实时数据（气象、交通、舆情等），自动评估事件等级与影响范围，推荐调度方案与资源分配。",
                            "featureTags": ["多源数据实时整合", "事件等级自动评估", "调度方案推荐", "跨部门协调联动"]
                        },
                        {
                            "icon": "📊",
                            "name": "城市运行数据分析",
                            "tag": "决策数据化",
                            "desc": "整合城市管理、民生服务、经济运行等多维数据，AI 生成城市运行健康度评估与趋势预测。",
                            "featureTags": ["城市运行健康度评估", "民生服务效能分析", "经济运行趋势预测", "异常指标预警"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 政务方案",
                    "highlightDesc": "以 AI 智能体为核心，满足政务最严苛的安全合规要求，真正实现\"服务提质、基层减负、数据驱动\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "政务服务提质增效",
                            "desc": "AI 问答 7×24 即时响应，智能导办推荐最优路径与材料预审，群众办事少跑腿、一次办。",
                            "items": ["7×24 智能问答即时响应", "智能导办与材料预审", "一网通办线上线下联动"]
                        },
                        {
                            "num": "02",
                            "title": "基层减负自动化",
                            "desc": "报表台账 AI 自动生成，重复字段智能填充，报送一键提交，基层工作人员聚焦核心服务。",
                            "items": ["报表台账自动生成", "重复字段智能填充", "报送一键提交归档"]
                        },
                        {
                            "num": "03",
                            "title": "数据治理与共享",
                            "desc": "标准化接口打通各委办局数据，群众办事免重复提交，跨部门协同审批加速，数据共享率提升 30%。",
                            "items": ["跨部门数据标准打通", "群众材料免重复提交", "协同审批加速"]
                        },
                        {
                            "num": "04",
                            "title": "私有化安全部署",
                            "desc": "全栈私有化部署，数据不出域、操作可追溯、决策可审计，满足政务最严苛的安全合规要求。",
                            "items": ["数据不出域全程加密", "操作日志完整追溯", "决策过程可审计可解释"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为政务部门的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                },
                {
                    "id": "education",
                    "industryName": "教育行业",
                    "title": "AI 智能体解决方案",
                    "badge": "AI 驱动的智慧校园方案",
                    "desc": "基于 AI 智能体与企业微信生态，构建覆盖教学优化、智能批改、家校协同、行政提效的全场景智慧校园平台，驱动教育机构数字化转型，全面提升教学与管理质量。",
                    "stats": [
                        { "num": "60%+", "label": "教师批改工作量下降" },
                        { "num": "35%+", "label": "学生个性化学习成效提升" },
                        { "num": "50%+", "label": "行政事务处理效率提升" }
                    ],
                    "aiAssistant": {
                        "name": "教育 AI 智能助手",
                        "subTitle": "学情诊断 · 因材施教 · 提质减负",
                        "status": "教学正常进行",
                        "msgList": [
                            {
                                "title": "学情诊断",
                                "content": "本周高一(3)班数学平均分较上周提升 4.2 分，建议加强几何证明题专项训练。",
                                "tag": "学情提升"
                            },
                            {
                                "title": "智能批改",
                                "content": "已批改 142 份物理作业，主观题置信度 92%，标记 18 道存疑转人工复审。",
                                "tag": "批改提速"
                            },
                            {
                                "title": "个性化推荐",
                                "content": "根据学生错题分布，已为 27 名学生定制专属练习包，因材施教。",
                                "tag": "推荐生成"
                            }
                        ]
                    },
                    "painTitle": "教育数字化转型的核心挑战",
                    "painDesc": "从 K12 到高等教育，教学资源、师生负担与管理效率是三大共性难题，AI 正在给出全新解法。",
                    "painList": [
                        { "title": "教学资源分配不均", "desc": "优质师资集中在头部学校，偏远地区教学资源匮乏，个性化教学难以规模化实施。" },
                        { "title": "批改负担重反馈滞后", "desc": "教师日均批改数百份作业，反馈周期长，错题分析依赖手工统计，效率低且易遗漏。" },
                        { "title": "家校沟通效率低", "desc": "通知靠微信群转发、反馈靠家长会，信息碎片化、不对称，沟通成本高且难以追溯。" },
                        { "title": "教学数据沉淀难", "desc": "教研数据分散在各系统与纸面文件中，学情分析靠经验而非数据，教学决策缺乏依据。" },
                        { "title": "行政管理事务繁琐", "desc": "排课、考务、报修、审批等事务消耗大量教师时间，流程线下化、标准不一。" },
                        { "title": "校园安全管理难", "desc": "传统安防依赖人工巡逻，异常行为识别滞后，应急响应缺乏实时数据支撑。" }
                    ],
                    "sceneTitle": "覆盖\"教-学-管-服\"全链路",
                    "sceneDesc": "AI 智能体深入教学核心环节，从课前备课到课后反馈，从行政事务到校园安全，全方位赋能。",
                    "sceneList": [
                        {
                            "icon": "🧠",
                            "name": "AI 个性化学习路径",
                            "tag": "因材施教规模化",
                            "desc": "AI 分析学生知识点掌握度与学习习惯，自动生成个性化学习计划与推荐练习，实现千人千面的精准教学。",
                            "featureTags": ["知识图谱诊断", "自适应练习推荐", "学习路径规划", "弱项专项突破"]
                        },
                        {
                            "icon": "✏️",
                            "name": "AI 智能批改与错题分析",
                            "tag": "教师减负提效",
                            "desc": "AI 自动批改主观题与客观题，生成每份作业的错题归因分析，汇总全班学情报告，让教师聚焦教学而非批改。",
                            "featureTags": ["主观题智能评分", "错题归因分析", "全班学情报告", "批改数据追溯"]
                        },
                        {
                            "icon": "🤖",
                            "name": "AI 助教与课后辅导",
                            "tag": "7×24 智能答疑",
                            "desc": "基于课程知识库构建 AI 助教，学生随时提问即获解答与解析，支持多轮对话引导，延伸课堂学习到课后。",
                            "featureTags": ["多轮对话答疑", "解题步骤引导", "知识拓展推荐", "学习进度跟踪"]
                        },
                        {
                            "icon": "📱",
                            "name": "家校协同智能平台",
                            "tag": "沟通闭环透明化",
                            "desc": "基于企业微信构建家校统一入口，通知、成绩、考勤、课表一键触达，家长反馈即时响应，沟通全程可追溯。",
                            "featureTags": ["通知精准推送", "成绩与考勤查询", "家长反馈通道", "沟通记录追溯"]
                        },
                        {
                            "icon": "📈",
                            "name": "教学质量数据分析",
                            "tag": "数据驱动教研",
                            "desc": "整合课堂互动、作业、考试等全维度数据，AI 生成学情诊断与教学效果评估，支持教研组精准改进教学策略。",
                            "featureTags": ["学情诊断报告", "教学效果评估", "教研策略优化", "异常预警提醒"]
                        },
                        {
                            "icon": "🛡️",
                            "name": "校园安全智能监控",
                            "tag": "实时预警响应",
                            "desc": "视频 + AI 行为识别，实时检测校园异常事件（人员聚集、闯入禁区、烟火等），自动告警推送保卫处。",
                            "featureTags": ["异常行为检测", "禁区闯入告警", "烟火识别", "巡检记录自动化"]
                        }
                    ],
                    "highlightTitle": "为什么选择我们的 AI 教育方案",
                    "highlightDesc": "以 AI 智能体为核心，连接教学、管理、家校全场景，真正实现\"减负提质\"。",
                    "highlightList": [
                        {
                            "num": "01",
                            "title": "AI 深度赋能教学",
                            "desc": "从课前备课到课后反馈，AI 智能体贯穿教学全流程：智能批改释放教师时间，个性化推荐提升学习成效，AI 助教延伸课堂边界。",
                            "items": ["智能批改覆盖主流题型", "千人千面学习路径推荐", "7×24 AI 助教即时答疑"]
                        },
                        {
                            "num": "02",
                            "title": "家校协同透明闭环",
                            "desc": "基于企业微信统一入口，通知、成绩、考勤、课表等关键信息精准推送，家长反馈即时响应，消除信息不对称与沟通碎片化。",
                            "items": ["通知与成绩精准推送", "家长反馈即时处理", "沟通全程可追溯"]
                        },
                        {
                            "num": "03",
                            "title": "数据驱动教研决策",
                            "desc": "多维度教学数据自动采集与清洗，AI 生成学情诊断与教学效果评估，支持教研组精准优化教学策略与管理措施。",
                            "items": ["学情诊断与预警", "教学效果量化评估", "教研改进路径推荐"]
                        },
                        {
                            "num": "04",
                            "title": "一体化移动门户",
                            "desc": "整合教学、办公、生活服务到统一移动端，20+ 高频校园服务一键触达，师生一站式入口，降低 50% 系统运维成本。",
                            "items": ["教学办公一端聚合", "审批报修在线办理", "校园服务一键触达"]
                        }
                    ],
                    "ctaTitle": "让 AI 成为教育机构的核心竞争力",
                    "ctaDesc": "无论您处于数字化转型的哪个阶段，我们都可以从最具价值的单点场景开始，帮助您快速验证 AI 在业务中的真实回报。立即联系我们，获取专属方案与 POC 建议。",
                    "contactMail": "contact@sunjee.cn"
                }
            ]
        }
    },
    created() {
        this.$http('/Plan/GetTypeData').then(x => {
            if (x.data.length > 0) {
                this.menus = x.data.filter(z => z.name != '央企' && z.name != '国企')
            }
        })
        var i = 0
        if (this.$route.query.index) {
            i = Number(this.$route.query.index)
        }
        this.getInfo('', i)
    },
    mounted() {
        ul = document.getElementById('scrollcontainer');
        ul.addEventListener('mousedown', (e) => {
            isMouseDown = true;
        })
        ul.addEventListener('mousemove', (e) => {
            if (isMouseDown) {
                ul.scrollBy(-e.movementX, 0);
            }
        })
        ul.addEventListener('mouseup', (e) => {
            isMouseDown = false;
        })
        ul.addEventListener('mouseleave', (e) => {
            isMouseDown = false;
            autoScroll()
        })
        // 滚动速度，数值越大滚动越快（推荐0.5 ~ 2之间）
        const speed = 0.8;
        // 滚动方向 1=向右，-1=向左
        let direction = 1;
        // 最大可滚动距离 = 内容宽度 - 容器可视宽度
        const maxScroll = ul.scrollWidth - ul.clientWidth;

        let animateId;
        function autoScroll() {
            // 根据方向修改滚动值
            ul.scrollLeft += speed * direction;

            // 触达最右侧，切换向左回滚
            if (ul.scrollLeft >= maxScroll) {
                direction = -1;
            }
            // 回到最左侧，切换向右滚动
            if (ul.scrollLeft <= 0) {
                direction = 1;
            }
            animateId = requestAnimationFrame(autoScroll);
        }
        ul.addEventListener('mouseenter', () => cancelAnimationFrame(animateId))
        // 启动滚动
        autoScroll();
    },
    methods: {
        getInfo(id, i) {
            this.data = this.list[i]
            this.mindex = i
        },
        toc() {
            if (this.$isxj)
                window.open('https://work.weixin.qq.com/kfid/kfc54a4ebac7513c548')
            else
                window.open('https://work.weixin.qq.com/kfid/kfc31843ffccca81b46')
        },
        getmodule() {
            const rect = document.getElementById("module3").getBoundingClientRect()
            // 80：向上偏移80px，根据你导航栏高度自行修改数值
            const scrollTop = rect.top + window.scrollY - 150
            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            })
        }
    }
}

</script>
<style>
:root {
    --primary: #1a6cff;
    --primary-dark: #0d4cc4;
    --primary-light: #e8f1ff;
    --accent: #00c6ff;
    --dark: #0c1d36;
    --text: #1f2937;
    --text-light: #6b7280;
    --bg: #f8fafc;
    --border: #e5e7eb;
    --radius: 16px;
    --shadow: 0 4px 24px rgba(13, 76, 196, .08);
    --shadow-lg: 0 20px 60px rgba(13, 76, 196, .12);
    --gradient: linear-gradient(135deg, #1a6cff 0%, #00c6ff 100%)
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0
}

html {
    scroll-behavior: smooth
}

body {
    font-family: 'Inter', 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: var(--text);
    background: #fff;
    line-height: 1.7;
    overflow-x: hidden
}

a {
    text-decoration: none;
    color: inherit
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    /* padding: 0 24px */
}

.containercard {
    width: 100%;
    /* max-width: 1200px; */
    margin: 0 auto;
    /* padding: 0 24px */
}

/* Header */
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, .95);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border);
    transition: box-shadow .3s
}

.header.scrolled {
    box-shadow: 0 4px 20px rgba(0, 0, 0, .06)
}

.header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px
}

.logo {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 700;
    font-size: 18px;
    color: var(--dark)
}

.logo-icon {
    width: 40px;
    height: 40px;
    background: var(--gradient);
    border-radius: 10px;
    display: grid;
    place-items: center;
    color: #fff;
    font-weight: 800;
    font-size: 16px
}

.nav {
    display: flex;
    align-items: center;
    gap: 32px
}

.nav a {
    font-size: 15px;
    font-weight: 500;
    color: var(--text);
    transition: color .2s;
    position: relative
}

.nav a:hover,
.nav a.active {
    color: var(--primary)
}

.nav a.active::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--primary)
}

/* Industry Tabs */
.tabs-bar {
    background: var(--bg);
    padding: 28px 0;
    border-bottom: 1px solid var(--border);
    /* position: sticky;
    top: 72px;
    z-index: 999 */
}

.tabs-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap
}

.tab-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 22px;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 600;
    color: var(--text);
    background: #fff;
    border: 1.5px solid var(--border);
    cursor: pointer;
    transition: all .25s ease;
    user-select: none
}

.tab-btn:hover {
    border-color: var(--primary);
    color: var(--primary);
    background: var(--primary-light)
}

.tab-btn.active {
    background: var(--gradient);
    color: #fff;
    border-color: transparent;
    box-shadow: 0 6px 20px rgba(26, 108, 255, .25)
}

.tab-btn .tab-icon {
    font-size: 18px
}

/* Hero - left/right split */
.hero {
    position: relative;
    padding: 50px 0px;
    /* padding-top: 80px; */
    background: linear-gradient(180deg, #f0f7ff 0%, #fff 100%);
    overflow: hidden;
    padding-bottom: 30px;
}

.hero::before {
    content: '';
    position: absolute;
    top: 0px;
    right: -5%;
    width: 60%;
    height: 100%;
    background: radial-gradient(circle at 70% 30%, rgba(0, 198, 255, .15) 0%, transparent 60%), radial-gradient(circle at 80% 70%, rgba(26, 108, 255, .1) 0%, transparent 50%);
    pointer-events: none
}

.hero-inner {
    display: grid;
    grid-template-columns: 1.1fr 1fr;
    gap: 48px;
    /* align-items: center; */
    position: relative;
    z-index: 1
}

.hero-left .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 50px;
    font-size: 13px;
    font-weight: 500;
    color: var(--primary);
    margin-bottom: 24px;
    box-shadow: 0 2px 12px rgba(13, 76, 196, .06)
}

.hero-left .hero-badge span {
    width: 8px;
    height: 8px;
    background: var(--accent);
    border-radius: 50%;
    animation: pulse 2s infinite
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1)
    }

    50% {
        opacity: .7;
        transform: scale(1.2)
    }
}

.hero-left h1 {
    font-size: 40px;
    /* font-weight: 700; */
    line-height: 1.3;
    color: var(--dark);
    margin-bottom: 20px
}

.hero-left h1 .highlight {
    background: var(--gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text
}

.hero-left .hero-subtitle {
    font-size: 16px;
    color: var(--text-light);
    line-height: 1.8;
    margin-bottom: 28px;
    max-width: 540px
}

.hero-cta {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 32px
}

.hero-cta .btn-primary {
    background: var(--gradient);
    color: #fff
}

.hero-cta .btn-outline {
    color: var(--primary);
    border: 1.5px solid var(--primary);
    background: transparent
}

.hero-cta .btn-outline:hover {
    background: var(--primary-light)
}

.hero-stats {
    display: flex;
    gap: 36px;
    padding-top: 20px;
    border-top: 1px solid var(--border)
}

.hero-stats .stat-number {
    font-size: 28px;
    font-weight: 700;
    color: var(--primary);
    line-height: 1.2
}

.hero-stats .stat-label {
    font-size: 14px;
    color: var(--text-light)
}

/* AI Assistant Card */
.ai-card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 24px 60px rgba(13, 76, 196, .12), 0 4px 16px rgba(13, 76, 196, .06);
    position: relative
}

.ai-card-head {
    display: flex;
    align-items: center;
    gap: 14px;
    /* padding-bottom: 18px; */
    /* border-bottom: 1px solid var(--border) */
}

.ai-avatar {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    background: var(--gradient);
    color: #fff;
    display: grid;
    place-items: center;
    font-weight: 800;
    font-size: 18px;
    flex-shrink: 0
}

.ai-card-head h4 {
    font-size: 17px;
    font-weight: 700;
    color: var(--dark);
    margin-bottom: 3px
}

.ai-card-head p {
    font-size: 12px;
    color: var(--text-light)
}

.ai-card-head .status {
    position: absolute;
    top: 24px;
    right: 24px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #16a34a;
    background: #f0fdf4;
    padding: 5px 10px;
    border-radius: 50px
}

.ai-card-head .status::before {
    content: '';
    width: 6px;
    height: 6px;
    background: #16a34a;
    border-radius: 50%;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, .18)
}

.ai-msgs {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-top: 18px
}

.ai-msg {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    position: relative
}

.ai-msg .ai-dot {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--primary-light);
    color: var(--primary);
    display: grid;
    place-items: center;
    font-size: 12px;
    font-weight: 800;
    flex-shrink: 0;
    margin-top: 2px
}

.ai-msg .bubble {
    background: linear-gradient(135deg, #f5f9ff 0%, #eaf2ff 100%);
    border-radius: 14px;
    padding: 14px 16px;
    flex: 1;
    position: relative
}

.ai-msg .bubble h5 {
    font-size: 14px;
    font-weight: 700;
    color: var(--primary);
    margin-bottom: 6px
}

.ai-msg .bubble p {
    font-size: 13px;
    color: var(--text);
    line-height: 1.65;
    margin: 0
}

.ai-msg .bubble .tag {
    position: absolute;
    top: 14px;
    right: 14px;
    font-size: 11px;
    font-weight: 600;
    color: var(--text);
    background: #fff;
    padding: 3px 9px;
    border-radius: 50px;
    border: 1px solid var(--border);
    white-space: nowrap
}

.ai-msg .bubble .tag::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: var(--accent);
    border-radius: 50%;
    margin-right: 5px;
    vertical-align: middle
}

/* CTA */
.cta {
    padding: 0;
    background: #fff
}

.cta-section {
    background: linear-gradient(135deg, #0f5fff 0%, #00a8ff 60%, #00d2ff 100%);
    position: relative;
    overflow: hidden;
    /* padding: 90px 0; */
    margin-top: 80px;
}

/* .cta-section::before {
    content: '';
    position: absolute;
    top: -30%;
    right: -10%;
    width: 70%;
    height: 140%;
    background: radial-gradient(ellipse at 70% 40%, rgba(255, 255, 255, .18) 0%, transparent 55%), radial-gradient(ellipse at 80% 80%, rgba(255, 255, 255, .08) 0%, transparent 45%);
    pointer-events: none;
    z-index: 0
} */

/* .cta-section::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 160px;
    background: linear-gradient(180deg, transparent 0%, rgba(255, 255, 255, .12) 100%);
    pointer-events: none;
    z-index: 0
} */

.cta-inner {
    display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 56px;
    align-items: center;
    position: relative;
    z-index: 1
}

.cta-content h2 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.25;
    color: #fff;
    margin-bottom: 22px
}

.cta-content p {
    font-size: 17px;
    color: rgba(255, 255, 255, .9);
    line-height: 1.8;
    margin-bottom: 34px;
    max-width: 540px
}

.cta-actions {
    display: flex;
    gap: 16px;
    flex-wrap: wrap
}

.btn-cta-primary {
    background: #fff;
    color: var(--primary);
    box-shadow: 0 8px 28px rgba(0, 0, 0, .18)
}

.btn-cta-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 36px rgba(0, 0, 0, .22);
    background: #f8fbff
}

.btn-cta-outline {
    background: rgba(255, 255, 255, .1);
    color: #fff;
    border: 1.5px solid rgba(255, 255, 255, .5);
    backdrop-filter: blur(4px)
}

.btn-cta-outline:hover {
    background: rgba(255, 255, 255, .18);
    border-color: rgba(255, 255, 255, .8)
}

.cta-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 420px
}

.cta-visual .hero-visual {
    position: relative;
    width: 100%;
    max-width: 520px;
    height: auto;
    aspect-ratio: 520/420;
    display: flex;
    align-items: center;
    justify-content: center
}

.cta-visual .hero-visual svg {
    width: 100%;
    height: 100%;
    overflow: visible
}

.orbit-ring {
    fill: none;
    stroke: rgba(255, 255, 255, .22);
    stroke-width: 1.5;
    transform-origin: center;
    animation: orbitRotate 30s linear infinite
}

.orbit-ring-2 {
    animation-duration: 24s;
    animation-direction: reverse
}

.orbit-ring-3 {
    animation-duration: 18s
}

@keyframes orbitRotate {
    0% {
        transform: rotate(0deg)
    }

    100% {
        transform: rotate(360deg)
    }
}

.cube {
    animation: floatCube 6s ease-in-out infinite;
    transform-origin: center
}

.cube-2 {
    animation-delay: -2s
}

.cube-3 {
    animation-delay: -4s
}

@keyframes floatCube {

    0%,
    100% {
        transform: translateY(0)
    }

    50% {
        transform: translateY(-12px)
    }
}

/* Common Button */
.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 28px;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all .3s;
    border: none;
    outline: none
}

.btn-primary {
    background: var(--gradient);
    color: #fff;
    box-shadow: 0 8px 24px rgba(26, 108, 255, .3)
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(26, 108, 255, .4)
}

.btn-outline {
    background: transparent;
    color: var(--primary);
    border: 1.5px solid var(--primary)
}

.btn-outline:hover {
    background: var(--primary-light)
}

.btn-white {
    background: #fff;
    color: var(--primary);
    box-shadow: 0 4px 16px rgba(0, 0, 0, .08)
}

.btn-white:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, .12)
}

/* Sections */
.section {
    padding: 80px 0;
}

.section-header {
    text-align: center;
    max-width: 1200px;
    margin: 0 auto 50px
}

.section-label {
    display: inline-block;
    padding: 6px 16px;
    background: var(--primary-light);
    color: #000 !important;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 16px
}

.section-title {
    font-size: 34px;
    font-weight: 700;
    color: var(--dark);
    line-height: 1.25;
    margin-bottom: 16px
}

.section-desc {
    font-size: 16px;
    color: var(--text-light);
    line-height: 1.8
}

/* Slider - shared */
.slider-wrap {
    position: relative;
    margin: 0 -8px;
    overflow-x: auto;
    padding: 0px 50px;
}

.slider-wrap::-webkit-scrollbar {
    display: none
}

.slider {
    display: flex;
    /* gap: 25px; */
    justify-content: space-between;
    /* overflow-x: auto; */
    scroll-behavior: smooth;
    padding: 8px 0px 20px;
    scrollbar-width: none;
    -ms-overflow-style: none
}

.slider::-webkit-scrollbar {
    display: none
}

.slider-nav {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 8px
}

.slider-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff;
    border: 1.5px solid var(--border);
    color: var(--primary);
    display: grid;
    place-items: center;
    cursor: pointer;
    transition: all .25s;
    font-size: 18px
}

.slider-btn:hover {
    background: var(--gradient);
    color: #fff;
    border-color: transparent;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(26, 108, 255, .3)
}

.slider-btn:disabled {
    opacity: .4;
    cursor: not-allowed;
    transform: none;
    box-shadow: none
}

.slider-dots {
    display: flex;
    gap: 6px;
    align-items: center
}

.slider-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--border);
    transition: all .25s;
    cursor: pointer
}

.slider-dot.active {
    width: 24px;
    border-radius: 5px;
    background: var(--primary)
}

/* Pain Points - Target Layout (3+3 around center target) */
.pain-section {
    background: #fff;
    position: relative;
    overflow: hidden
}

/* .pain-section::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 680px;
    height: 680px;
    transform: translate(-50%, -50%);
    background: radial-gradient(circle, rgba(255, 180, 80, .07) 0%, rgba(255, 80, 80, .04) 40%, transparent 70%);
    pointer-events: none;
    z-index: 0
} */

.pain-layout {
    position: relative;
    /* display: grid;
    grid-template-columns: 1fr 320px 1fr; */
    display: flex;
    justify-content: space-between;
    /* gap: 24px; */
    /* align-items: start; */
    padding: 30px 0 50px;
    z-index: 1
}

.pain-col {
    display: flex;
    flex-direction: column;
    gap: 48px
}

.pain-col-left .pain-card {
    margin-left: auto;
    max-width: 420px;
    cursor: pointer;
}

.pain-col-left .pain-card:nth-child(1) {
    /* margin-top: 36px */
    position: relative;
    left: 50px;
}

.pain-col-left .pain-card:nth-child(2) {
    /* margin-top: 36px */
}

.pain-col-left .pain-card:nth-child(3) {
    /* margin-top: -12px */
    position: relative;
    left: 50px;
}

.pain-col-right .pain-card {
    margin-right: auto;
    max-width: 420px
}

.pain-col-right .pain-card:nth-child(1) {
    margin-top: 30px;
    position: relative;
    right: 50px;

}

.pain-col-right .pain-card:nth-child(2) {
    /* margin-top: -10px */
}

.pain-col-right .pain-card:nth-child(3) {
    /* margin-top: 30px */
    position: relative;
    right: 50px;
}

.pain-card {
    background: #fff;
    border-radius: 18px;
    padding: 24px 26px;
    border: 1px solid var(--border);
    transition: all .3s;
    position: relative;
    box-shadow: 0 4px 16px rgba(13, 76, 196, .04);
    cursor: pointer;
}

.pain-card:hover {
    background: linear-gradient(135deg, #1a6cff 0%, #00c6ff 100%);
    color: #fff !important;
}

.pain-card h3 {
    font-size: 18px;
    font-weight: 700;
    /* color: var(--dark); */
    margin-bottom: 8px;
    line-height: 1.4
}

.pain-card p {
    font-size: 14px;
    /* color: var(--text-light); */
    line-height: 1.7
}

.pain-card-highlight {
    background: linear-gradient(135deg, #1a6cff 0%, #00c6ff 100%);
    color: #fff;
    border: none;
    box-shadow: 0 16px 40px rgba(26, 108, 255, .3);
    position: relative;
    overflow: hidden
}

/* .pain-card-highlight::before {
    content: '';
    position: absolute;
    top: -30%;
    right: -20%;
    width: 160px;
    height: 160px;
    background: radial-gradient(circle, rgba(255, 255, 255, .18) 0%, transparent 70%);
    pointer-events: none
} */

/* .pain-card-highlight h3 {
    color: #fff;
    font-size: 19px
} */

/* .pain-card-highlight p {
    color: rgba(255, 255, 255, .92)
} */

/* Scenario Cards - slider (3 visible, 6 total) */
.scn-slider .scenario-card {
    /* flex: 0 0 calc((100% - 40px) / 3); */
    /* min-width: 560px; */
    width: 560px;
    background: #f8fafc;
    border-radius: 24px;
    padding: 32px;
    border: 1px solid var(--border);
    transition: all .3s;
    position: relative;
    overflow: hidden
}

.scn-slider .scenario-card::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 160px;
    height: 160px;
    background: radial-gradient(circle, rgba(26, 108, 255, .06) 0%, transparent 70%);
    pointer-events: none
}

.scn-slider .scenario-card:hover {
    transform: translateY(-2px);
}

.scenario-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px
}

.scenario-icon {
    width: 65px;
    height: 65px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid var(--border);
    display: grid;
    place-items: center;
    font-size: 24px;
    flex-shrink: 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .04)
}

.scenario-title-group h3 {
    font-size: 18px;
    font-weight: 700;
    color: var(--dark);
    margin-bottom: 4px
}

.scenario-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    color: var(--primary);
    background: var(--primary-light);
    padding: 4px 10px;
    border-radius: 50px
}

.scn-slider .scenario-card p {
    font-size: 14px;
    color: var(--text-light);
    line-height: 1.8;
    margin-bottom: 16px;
    margin: 30px 0px;
}

.scenario-features {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 20px;
    margin-bottom: 8px;
}

.scenario-features span {
    font-size: 13px;
    color: var(--text);
    background: var(--bg);
    padding: 5px 12px;
    border-radius: 8px;
    border: 1px solid var(--border)
}

/* Highlights - Dark */
.highlights {
    background: linear-gradient(180deg, var(--dark) 0%, #0a1628 100%);
    color: #fff;
    position: relative;
    overflow: hidden;
    padding-bottom: 0px;
}

.highlights::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(26, 108, 255, .2) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(0, 198, 255, .15) 0%, transparent 50%);
    pointer-events: none
}

.highlights .section-title,
.highlights .section-label,
.highlights .section-desc {
    color: #fff
}

.highlights .section-desc {
    opacity: .8
}

.highlights-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    position: relative;
    z-index: 1
}

.highlight-card {
    background: rgba(255, 255, 255, .06);
    border: 1px solid rgba(255, 255, 255, .1);
    border-radius: 24px;
    padding: 32px;
    backdrop-filter: blur(10px);
    transition: all .3s
}

.highlight-card:hover {
    background: rgba(255, 255, 255, .1);
    transform: translateY(-2px)
}

.highlight-number {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: var(--gradient);
    display: grid;
    place-items: center;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px
}

.highlight-card h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px
}

.highlight-card p {
    font-size: 14px;
    opacity: .8;
    line-height: 1.8
}

.highlight-card ul {
    margin-top: 12px;
    list-style: none
}

.highlight-card li {
    font-size: 13px;
    opacity: .85;
    padding: 5px 0;
    padding-left: 18px;
    position: relative
}

.highlight-card li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: var(--accent);
    font-weight: 700
}

/* CTA */
.cta {
    background: var(--gradient);
    padding: 80px 0;
    position: relative;
    overflow: hidden
}

.cta::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, .2) 0%, transparent 40%), radial-gradient(circle at 20% 80%, rgba(255, 255, 255, .15) 0%, transparent 40%);
    pointer-events: none
}

.cta-inner {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 60px;
    align-items: center;
    position: relative;
    z-index: 1
}

.cta h2 {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
    line-height: 1.3;
    margin-bottom: 20px
}

.cta p {
    font-size: 16px;
    color: rgba(255, 255, 255, .9);
    margin-bottom: 28px;
    line-height: 1.8
}

.cta-actions {
    display: flex;
    gap: 16px;
    flex-wrap: wrap
}

.cta-contact {
    background: rgba(255, 255, 255, .12);
    border: 1px solid rgba(255, 255, 255, .2);
    border-radius: 24px;
    padding: 32px;
    color: #fff;
    backdrop-filter: blur(10px)
}

.cta-contact h4 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px
}

.cta-contact-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    font-size: 14px;
    opacity: .95
}

.cta-contact-item .icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(255, 255, 255, .15);
    display: grid;
    place-items: center;
    font-size: 16px
}

/* Footer */
.footer {
    background: var(--dark);
    color: #fff;
    padding: 40px 0;
    text-align: center
}

.footer p {
    font-size: 14px;
    opacity: .7;
    margin-bottom: 6px
}

.footer-links {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-bottom: 14px
}

.footer-links a {
    font-size: 14px;
    opacity: .8;
    transition: opacity .2s
}

.footer-links a:hover {
    opacity: 1
}

/* Industry Content Switch */
.industry-content {
    display: none
}

.industry-content.active {
    display: block
}

.reveal {
    cursor: pointer;
}

/* Scroll reveal */
/* 
.reveal {
    opacity: 0;
    transform: translateY(28px);
    transition: all .3s ease
}

.reveal.visible {
    opacity: 1;
    transform: translateY(0)
}
*/

/* Responsive */
@media(max-width:1024px) {
    .hero-inner {
        grid-template-columns: 1fr;
        gap: 40px
    }

    .hero-left h1 {
        font-size: 38px
    }

    /* .pain-layout {
        grid-template-columns: 1fr 1fr;
        gap: 24px
    } */

    /* .pain-col-left .pain-card,
    .pain-col-right .pain-card {
        max-width: 100%;
        margin: 0
    }

    .pain-col-left .pain-card:nth-child(n),
    .pain-col-right .pain-card:nth-child(n) {
        margin-top: 0
    } */

    .scn-slider .scenario-card {
        flex: 0 0 calc((100% - 20px) / 2);
        min-width: 260px
    }

    .highlights-grid {
        grid-template-columns: repeat(2, 1fr)
    }

    .cta-inner {
        grid-template-columns: 1fr;
        gap: 40px
    }

    .cta-visual {
        min-height: 340px
    }
}

@media(max-width:768px) {
    .nav {
        display: none
    }

    .hero-left h1 {
        font-size: 30px
    }

    .section-title {
        font-size: 24px
    }

    /* .pain-layout {
        grid-template-columns: 1fr;
        gap: 20px
    } */

    .scn-slider .scenario-card {
        flex: 0 0 85%;
        min-width: 0
    }

    .highlights-grid,
    .cta-inner {
        grid-template-columns: 1fr
    }

    .hero-stats {
        gap: 20px
    }

    .hero-stats .stat-number {
        font-size: 22px
    }

    .cta-content h2 {
        font-size: 26px
    }

    .cta-visual {
        min-height: 280px
    }

    .tabs-inner {
        gap: 6px
    }

    .tab-btn {
        padding: 8px 16px;
        font-size: 13px
    }

    .ai-msg .bubble .tag {
        position: static;
        display: inline-block;
        margin-top: 8px
    }
}
</style>
<style scoped>
.mindex {
    border-right: 3px solid #1e66d1;
    position: relative;
    right: -3px;
    color: #1e66d1;
    background: linear-gradient(to right, #f9fdff, #ffffff);
}

.menu:hover {
    border-right: 3px solid #1e66d1;
    position: relative;
    right: -3px;
    color: #1e66d1;
    background: linear-gradient(to right, #f9fdff, #ffffff);
}
</style>